import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import OnVisible, { setDefaultProps } from 'react-on-visible';
import { detect } from 'detect-browser';

setDefaultProps({
    bounce: true,
    visibleClassName: 'appear',
    percent: 100,
});

import { fetchWork } from '../requests/work_request';

import Header from '../components/Header';
import Loader from '../components/Loader';
import Overview from '../components/Pages/WorkOverview/Overview';
import Footer from '../components/Footer';

class Work extends Component {
    scrollToTop(scrollDuration) {
        const scrollHeight = window.scrollY,
            scrollStep = Math.PI / (scrollDuration / 15),
            cosParameter = scrollHeight / 2;
        var scrollCount = 0,
            scrollMargin,
            scrollInterval = setInterval(function () {
                if (window.scrollY !== 0) {
                    scrollCount += 1;
                    scrollMargin =
                        cosParameter -
                        cosParameter * Math.cos(scrollCount * scrollStep);
                    window.scrollTo(0, scrollHeight - scrollMargin);
                } else clearInterval(scrollInterval);
            }, 15);
    }
    componentDidMount() {
        document.title = `Work - Friends for Brands`;
        const browser = detect();
        if (browser.name === 'ie') {
            window.scrollTo(0, 0);
        } else {
            this.scrollToTop(1000);
        }
    }
    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        if (willMount) {
            this.props.fetchWork('work');
        }
    }

    filterByActiveWork() {
        const workList = this.props.work.posts;
        const result = workList.filter((x) => !x.acf.work_archived);
        return result;
    }

    render() {
        return (
            <div className="work page overviewpage">
                <main>
                    <Header />
                    <div id="main-container">
                        <div className="content-container">
                            <div className="clearfix" />
                            <Link
                                to={{
                                    pathname: '/behind-the-scenes',
                                    state: { transition: 'slideLeft' },
                                }}
                                className="nav-btn">
                                <i className="icon icon-arrow_right" />
                                <span>Behind the scenes</span>
                            </Link>

                            <Overview
                                work={
                                    this.props.work.fetched &&
                                    this.filterByActiveWork()
                                }
                            />
                            <Loader
                                loaded={
                                    this.props.work.fetched ||
                                    this.props.work.failed
                                }
                            />
                            {this.props.work.failed && (
                                <h2>
                                    :(!
                                    <br />
                                    Something went wrong. Try it again later.
                                    <br />
                                    <br />
                                </h2>
                            )}
                            <OnVisible className="not-appeared">
                                <div className="overviewpage__link-container">
                                    <Link
                                        className="cta-btn black"
                                        to={{
                                            pathname: `/archive/`,
                                            state: {
                                                transition: 'slideUp',
                                            },
                                        }}>
                                        Archived cases
                                    </Link>
                                </div>
                            </OnVisible>
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        );
    }
}

function mapStateToProps({ work }) {
    return { work };
}

export default withRouter(connect(mapStateToProps, { fetchWork })(Work));



// WEBPACK FOOTER //
// ./src/containers/Work.jsx